import {
  DoseSpotPharmacySearchParams,
  DoseSpotPharmacySearchResponse,
} from "@/types/dosespot";

import { requestData } from "@/api/api-config";

export async function searchDoseSpotPharmacies(
  params: DoseSpotPharmacySearchParams,
): Promise<DoseSpotPharmacySearchResponse | null> {
  return await requestData<DoseSpotPharmacySearchResponse>(
    "dosespot/pharmacies/search",
    "get",
    {
      searchParams: params,
    },
    false,
  );
}
